import { connectNetwork } from 'lib/NetworkProvider'
import View from 'lib/View'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { TOOLBAR_ACTIONS } from '../actions/toolbar'
import { Machine } from '../components'

class SingleMachine extends Component {
    constructor(props) {
        super(props)
        let { machine } = this.props.match.params

        this.state = {
            machine,
        }
    }

    componentDidUpdate() {}

    componentDidMount() {}

    render() {
        let { machine } = this.state
        console.log('Loading machine', machine)
        return (
            <View column fullw fullh>
                <Machine forcedOpen={true} showDetails={true} machineId={machine} type="full" />
            </View>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toolbarRequest: (result) => TOOLBAR_ACTIONS.request(result, dispatch),
        toolbarResult: (result) => TOOLBAR_ACTIONS.result(result, dispatch),
        toolbarError: (result) => TOOLBAR_ACTIONS.error(result, dispatch),
    }
}

const mapStateToProps = (state) => {
    return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectNetwork(SingleMachine)))